import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { useTheme, Box, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { InfoCircle } from '../../../../assets';
import { CloseDialogAction } from '../../../../components/shared/dialogs/CloseDialogAction';

export interface SimpleDialogProps {
  readonly open: boolean;
  readonly note: string;
  readonly onClose: () => void;
}

export function NoteModal(props: SimpleDialogProps) {
  const { t } = useTranslation('common');
  const theme = useTheme();

  const { onClose, note, open } = props;

  return (
    <Dialog
      fullWidth
      maxWidth='sm'
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '& .MuiDialog-container': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <InfoCircle color={theme.palette.custom.blue[500]} />
        </Box>
        <CloseDialogAction onCancel={onClose} />
      </DialogTitle>

      <DialogContent>
        <Stack>
          <Typography variant='textLG'
            fontWeight={600}>{t('transactions.note')}</Typography>
          <Typography color="textSecondary"
            sx={{ mt: 1 }}
            variant="textSM">
            {note}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Box width='100%'>
          <Button
            fullWidth
            variant="secondary"
            size="md"
            onClick={onClose}>
            {t('close')}
          </Button>
        </Box>
      </DialogActions>
    </Dialog >
  );
}
